import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import SubRouteAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route.entity';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule, MatDialogContent, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TranslocoModule } from '@ngneat/transloco';
import { ConfigurationFiltersComponent } from 'app/modules/components/filters/configuration-filters/configuration-filters.component';
import { VechicleService } from 'app/modules/components/transport/vechicle/vehicle.service';
import { getCode } from 'app/utils/method';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { BusinessPartner, Route, RouteAreaModal, SubRouteModal, Trip, Vehicle } from '../../dto/routes-detail-by-businesss-partnert-vehicle-dto';
import { VehiclesFiltersComponent } from 'app/modules/components/filters/vehicles-filters/vehicles-filters.component';
import { BusinessPartnerService } from 'app/modules/components/business-partners/business-partner/business-partner.service';
import { BusinessPartnersFiltersComponent } from 'app/modules/components/filters/business-partners-filters/business-partners-filters.component';
import { DateHelper } from 'app/utils/date.helper';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';
import { TimeDifferencePipe } from 'app/pipes/diference-time.pipe';
import { RouteInfo } from 'app/modules/components/routing/sub-routes/client-route-locator/interfaces/client-route-locator.interface';
import RouteAttributes from '@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity';
import { Router } from '@angular/router';
import { OverlayRef } from '@angular/cdk/overlay';

@Component({
  selector: 'app-routes-detail-by-business-partner-vehicle',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatDialogContent,
    ConfigurationFiltersComponent,
    MatTableModule,
    MatCheckboxModule,
    TranslocoModule,
    MatIconModule,
    NgxMatSelectSearchModule,
    MatOptionModule,
    MatPaginatorModule,
    MatMenuModule,
    VehiclesFiltersComponent,
    BusinessPartnersFiltersComponent,
    FormatOtherDateHourPipe,
    TimeDifferencePipe,
  ],
  templateUrl: './routes-detail-by-business-partner-vehicle.component.html',
  styleUrl: './routes-detail-by-business-partner-vehicle.component.scss'
})
export class RoutesDetailByBusinessPartnerVehicleComponent {
  @Input() parameterId: string[] = [];
  @Input() parameterBusinessPartnerId: string[] = [];
  @Input() typeModal: string = "vehicle";
  @Input() showTablePrincipal: boolean = true;
  @Input() showSubRoutes: boolean = false;
  @Input() showTrips: boolean = false;
  @Input() search: boolean = false;

  @ViewChild("routesModal") routesModal!: TemplateRef<any>;

  dialogRefRoutesDetail: MatDialogRef<any>;

  @ViewChild("tripsModal") tripsModal!: TemplateRef<any>;

  dialogRefTripsDetail: MatDialogRef<any>;

  getCode = getCode;
  displayedColumns: string[] = [
    "name",
    "businessPartner",
    "type",
    "plate",
    "action"
  ];

  displayedColumnsBusinessPartner: string[] = [
    "name",
    "type",
    "action"
  ];

  displayedColumnsRoutes: string[] = [
    "route",
    "territory",
    "saleOffice",
    "assignedUser"
  ];

  displayedColumnsTrips: string[] = [
    "id",
    "subRoute",
    "territory",
    "function",
    "date",
    "user"
  ];

  //Data business Partner
  dataSourceCustomer = new MatTableDataSource<BusinessPartner>([]);


  //Data vehicle
  dataSourceVehicle = new MatTableDataSource<Vehicle>([]);

  //Data Routes
  dataSourceRoutes = new MatTableDataSource<RouteAreaModal>([]);

  //Data Trips
  dataSourceTrips = new MatTableDataSource<SubRouteModal>([]);

  @ViewChild(VehiclesFiltersComponent) vehicleFiltersComponent: VehiclesFiltersComponent;

  // Propiedad para el observador
  private resizeObserver: ResizeObserver | null = null;

  @ViewChild(BusinessPartnersFiltersComponent) businessPartnersFiltersComponent: BusinessPartnersFiltersComponent;

  //pagination Info
  totalItems = 0
  pageSize = 100
  pageIndex: number = 1;


  form: FormGroup;
  constructor(
    private vehicleService: VechicleService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<RoutesDetailByBusinessPartnerVehicleComponent>,
    private readonly businessService: BusinessPartnerService,
    private readonly router: Router,
    private elementRef: ElementRef
  ) {
    this.form = this.fb.group({
      vehicleId: [],
      searchVehicles: [''],
      assignedUserId: [],
      searchAssignedUser: ['']
    });
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  ngOnInit(): void {
    if (this.typeModal === 'vehicle' && this.parameterId.length > 0) {
      this.getTrips();
    }

    if (this.typeModal === 'businessPartner' && this.parameterId.length > 0) {
      this.getBusinessPartner();
    }

    this.form.get('vehicleId')?.valueChanges.subscribe(value => {
      this.getTripsBySelect(this.form.get("vehicleId").value);

      if (this.form.get('vehicleId')?.value?.length === 0) {
        this.dataSourceVehicle.data = [];
      }

      setTimeout(() => {
        this.forceSelectReposition();
      }, 400);
    });

    this.form.get('assignedUserId')?.valueChanges.subscribe(value => {
      this.getBusinessPartnerSelected(this.form.get("assignedUserId").value);
      if (this.form.get('assignedUserId')?.value?.length === 0) {
        this.dataSourceCustomer.data = [];
      }

      setTimeout(() => {
        this.forceSelectBusinessReposition();
      }, 400);
    });
  }

  forceSelectReposition(): void {
    const select = this.vehicleFiltersComponent?.matSelect;

    if (select && select.panelOpen) {
      const overlayDir: any = (select as any)._overlayDir;

      const overlayRef: any = overlayDir?._overlayRef;

      if (overlayRef) {
        overlayRef.updatePosition();
      }
    }
  }

  forceSelectBusinessReposition(): void {
    const select = this.businessPartnersFiltersComponent?.matSelect;

    if (select && select.panelOpen) {
      const overlayDir: any = (select as any)._overlayDir;

      const overlayRef: any = overlayDir?._overlayRef;

      if (overlayRef) {
        overlayRef.updatePosition();
      }
    }
  }

  onTypeModalChange(value: string) {
    this.typeModal = value;

    if (this.parameterBusinessPartnerId.length > 0 && this.typeModal === 'businessPartner') {
      this.parameterId = this.parameterBusinessPartnerId;
      this.getBusinessPartner();
    } else if (this.parameterBusinessPartnerId.length > 0) {
      this.parameterId = this.parameterId;
      this.getTrips();
    }
  }

  getBusinessPartnerSelected(values: string[]) {
    this.parameterId = values;
    this.getBusinessPartner();
  }

  getBusinessPartner(): void {
    this.businessService
      .getWithTripsInfo(
        {
          limitPerPage: this.pageSize,
          currentPage: this.pageIndex,
          sort: '_id',
          sortDirection: 'DESC',
        },
        this.parameterId
      )
      .subscribe((data) => {
        this.dataSourceCustomer.data = data.data;

        if (!this.showTablePrincipal) {
          if (this.showSubRoutes) {
            this.openRoutesModal(this.dataSourceCustomer.data[0].subRoutes, this.dataSourceCustomer.data[0]?.name, this.dataSourceCustomer.data[0]?.externalKeys?.code);
          } else {
            this.openTripsModal(this.dataSourceCustomer.data[0].currentTrips, this.dataSourceCustomer.data[0]?.name, this.dataSourceCustomer.data[0]?.externalKeys?.code);
          }
        }
      });
  }

  goToTravel(element: SubRouteModal) {
    if (element?.id) {
      const queryParams = { tripId: element.id };
      const urlTree = this.router.createUrlTree(
        ["monitor", "principal-screen"],
        { queryParams }
      );
      const absoluteUrl =
        window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, "_blank");
    }
  }

  hasTrip(element: SubRouteModal): boolean {
    return !!element?.id;
  }

  getTripsBySelect(values: string[]) {
    this.parameterId = values;
    this.getTrips();
  }

  getTerritoriesRoutes(subRoutes: RouteAreaModal): RouteInfo[] {
    return subRoutes.routes || [];
  }

  getTerritoriesTrips(trip: Trip): RouteInfo[] {
    return trip.routes || [];
  }

  getTrips(): void {
    this.vehicleService
      .getWithTripsInfo(
        {
          limitPerPage: this.pageSize,
          currentPage: this.pageIndex,
          sort: '_id',
          sortDirection: 'DESC',
        },
        this.parameterId
      )
      .subscribe((data) => {
        this.dataSourceVehicle.data = data.data;
        // this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;

        if (!this.showTablePrincipal) {
          if (this.showSubRoutes) {
            this.openRoutesModal(this.dataSourceVehicle.data[0].subRoutes, this.dataSourceVehicle?.data[0]?.name, this.dataSourceVehicle.data[0]?.externalKeys?.code);
          } else {
            this.openTripsModal(this.dataSourceVehicle.data[0].currentTrips, this.dataSourceVehicle?.data[0]?.name, this.dataSourceVehicle.data[0]?.externalKeys?.code);
          }
        }
      });
  }

  openRoutesModal(subRoutes: SubRouteAttributes[], assignedUser?: string, assignedUserCode?: string): void {
    this.dataSourceRoutes.data = [];
    subRoutes.forEach((subRoute: SubRouteAttributes) => {
      let routes: RouteInfo[] = [];

      subRoute.routes.forEach((route: RouteAttributes) => {
        let routeRegister: RouteInfo = {
          _id: route._id.toString(),
          id: route.id,
          name: route.name,
          statusId: route.statusId,
          externalKeys: route.externalKeys
        }

        routes = [...routes, routeRegister];
      })

      let register: RouteAreaModal = {
        _id: subRoute._id.toString(),
        id: 0,
        nameSubRoute: subRoute.name,
        salesOffice: subRoute.salesOffice?.name,
        assignedUser: assignedUser ? assignedUser : subRoute?.responsibleBusinessPartner?.name,
        salesOfficeCode: subRoute?.salesOffice?.externalKeys?.code ? subRoute?.salesOffice?.externalKeys?.code : '',
        assignedUserCode: assignedUserCode ? assignedUserCode : subRoute?.responsibleBusinessPartner?.externalKeys?.code,
        subRouteCode: subRoute.externalKeys?.code ? subRoute.externalKeys?.code : '',
        routes: routes
      }

      this.dataSourceRoutes.data = [...this.dataSourceRoutes.data, register]
    })

    // Ahora el modal se abre siempre que esta función sea llamada
    if (this.showTablePrincipal) {
      this.dialogRefRoutesDetail = this.dialog.open(this.routesModal, {
        panelClass: "form-modal-component",
        disableClose: true
      });
      this.dialogRefRoutesDetail.afterClosed().subscribe((result) => {
        result
      });
    }
  }

  openTripsModal(trips: Trip[], assignedUser?: string, assignedUserCode?: string): void {
    this.dataSourceTrips.data = [];

    trips.forEach((trip: Trip) => {
      let routes: RouteInfo[] = [];

      trip.routes.forEach((route: Route) => {
        let routeRegister: RouteInfo = {
          _id: route._id,
          id: route.id,
          name: route.name,
          statusId: route.statusId,
          externalKeys: route.externalKeys
        }

        routes = [...routes, routeRegister];
      })

      let register: SubRouteModal = {
        _id: trip._id,
        id: trip.id,
        statusId: trip.statusId,
        nameSubRoute: trip.subRoute?.name,
        function: trip.subRoute?.function?.name,
        assignedUser: assignedUser ? assignedUser : trip.user?.business_partner_id ? trip.user?.business_partner_name : trip.user?.user_login?.username,
        subRouteCode: trip.subRoute?.externalKeys?.code,
        functionCode: trip.subRoute?.function?.code,
        dateHourEndTeoric: trip.dateHourEndTeoric,
        dateHourStartTeoric: trip.dateHourStartTeoric,
        assignedUserCode: assignedUserCode ? assignedUserCode : trip.user?.business_partner_id ? trip.user?.business_partner_external_keys?.code : '',
        routes: routes
      }

      this.dataSourceTrips.data = [...this.dataSourceTrips.data, register];
    })

    // Ahora el modal se abre siempre que esta función sea llamada
    if (this.showTablePrincipal) {
      this.dialogRefTripsDetail = this.dialog.open(this.tripsModal, {
        panelClass: "form-modal-component",
        disableClose: true
      });
      this.dialogRefTripsDetail.afterClosed().subscribe((result) => {
        result
      });
    }

  }
}
